import { ISSUE_DETAIL_URL } from './const';
import { ContactUsFormValues, IssueDetailResponseData, PostIssueDetailResponseData } from './types';
import { preloadedGET } from '../../../utils/preloadApi';
import { POST } from '@packages/dataFetch';

export async function fetchDetailData() {
	const response = await preloadedGET<IssueDetailResponseData>(ISSUE_DETAIL_URL);

	return response.data;
}

export async function postDetailData(data: ContactUsFormValues) {
	const response = await POST<PostIssueDetailResponseData>(ISSUE_DETAIL_URL, { data });

	return response.data;
}
